import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
export var getRetailer = function getRetailer() {
  return getGlobalProperty("retailer");
};
export var isRetailer = function isRetailer() {
  return getRetailer() !== undefined;
};
export var getRetailerToken = function getRetailerToken() {
  var _getRetailer;
  return (_getRetailer = getRetailer()) === null || _getRetailer === void 0 ? void 0 : _getRetailer.token;
};
export var getRetailerEmail = function getRetailerEmail() {
  var _getRetailer2;
  return (_getRetailer2 = getRetailer()) === null || _getRetailer2 === void 0 ? void 0 : _getRetailer2.email_address;
};
export var getRetailerBusinessName = function getRetailerBusinessName() {
  var _getRetailer3;
  return (_getRetailer3 = getRetailer()) === null || _getRetailer3 === void 0 ? void 0 : _getRetailer3.name;
};
export var getRetailerCountry = function getRetailerCountry() {
  var _getRetailer$country, _getRetailer4, _getRetailerDefaultSh;
  return (_getRetailer$country = (_getRetailer4 = getRetailer()) === null || _getRetailer4 === void 0 ? void 0 : _getRetailer4.country) !== null && _getRetailer$country !== void 0 ? _getRetailer$country : (_getRetailerDefaultSh = getRetailerDefaultShippingAddress()) === null || _getRetailerDefaultSh === void 0 ? void 0 : _getRetailerDefaultSh.country;
};
export var getRetailerTaxableCountry = function getRetailerTaxableCountry() {
  var _getRetailerDefaultSh2, _getRetailerDefaultSh3;
  return (_getRetailerDefaultSh2 = (_getRetailerDefaultSh3 = getRetailerDefaultShippingAddress()) === null || _getRetailerDefaultSh3 === void 0 ? void 0 : _getRetailerDefaultSh3.country) !== null && _getRetailerDefaultSh2 !== void 0 ? _getRetailerDefaultSh2 : getRetailerCountry();
};
export var getRetailerActiveMemberships = function getRetailerActiveMemberships() {
  var _getRetailer5;
  var memberships = (_getRetailer5 = getRetailer()) === null || _getRetailer5 === void 0 ? void 0 : _getRetailer5.memberships;
  return memberships === null || memberships === void 0 ? void 0 : memberships.find(function (membership) {
    return membership.active;
  });
};
var getRetailerDefaultShippingAddress = function getRetailerDefaultShippingAddress() {
  var _getRetailer6;
  return (_getRetailer6 = getRetailer()) === null || _getRetailer6 === void 0 ? void 0 : _getRetailer6.default_shipping_address;
};